import type { AppRouteRecordRaw, AppRouteModule } from '@/router/types';
import { PAGE_NOT_FOUND_ROUTE, REDIRECT_ROUTE } from '@/router/routes/basic';

import { PageEnum } from '@/enums/pageEnum';
import { t } from '@/hooks/web/useI18n';

// import.meta.globEager() 直接引入所有的模块 Vite 独有的功能
const modules = import.meta.globEager('./modules/**/*.ts');
const routeModuleList: AppRouteModule[] = [];

// 加入到路由集合中
Object.keys(modules).forEach((key) => {
  const mod = modules[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routeModuleList.push(...modList);
});

export const asyncRoutes = [];

// 根路由
export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: PageEnum.BASE_HOME,
  meta: {
    title: 'Root',
  },
};
//系统首页
import dashboard from './modules/dashboard';
//应用首页
import AppRoute from './modules/appRoute';
//应用首页
import aiModule from './modules/aiModule';
//更新日志
import updateLogRoute from './modules/updateLog';
import jieSeriesDashboardRoutes from '@/views/jieSeriesDashboard/router/routes';
//全流程追溯（静态演示）
import fullProcessTraceRoute from './modules/fullProcessTrace';
//登陆页
export const LoginRoute: AppRouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import(/* webpackChunkName: "login" */ '@/views/sys/login/Login.vue'),
  meta: {
    title: t('routes.basic.login'),
  },
};


//全局搜索
export const SearchRoute: AppRouteRecordRaw = {
  path: '/globalSearch',
  name: 'globalSearch',
  component: () => import(/* webpackChunkName: "globalSearch" */ '@/views/dashboard/globalSearch'),
  meta: {
    title: t('routes.basic.globalSearch'),
  },
};

// Basic routing without permission
// 未经许可的基本路由
export const basicRoutes = [
  ...aiModule,
  ...updateLogRoute,
  ...jieSeriesDashboardRoutes,
  ...fullProcessTraceRoute,
  ...AppRoute,
  LoginRoute,
  dashboard,
  RootRoute,
  REDIRECT_ROUTE,
  PAGE_NOT_FOUND_ROUTE,
  SearchRoute,
];
